export default {
  "apiKey": "AIzaSyDsD-kl-G6ZaE_UBZRp9PUpi3ytJuI4BLU",
  "authDomain": "hideaway-dev.firebaseapp.com",
  "databaseURL": "https://hideaway-dev.firebaseio.com",
  "projectId": "hideaway-dev",
  "storageBucket": "hideaway-dev.appspot.com",
  "messagingSenderId": "546688619837",
  "appId": process.env.VUE_APP_FIREBASE_APP_ID
}